import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { getMaxPatronHeight } from "@/service/patron/patron-image";
import { trans } from "@/service/i18n/i18n";

type AsidePatronType =
  | "tutorial"
  | "clinical_case"
  | "article"
  | "calculator"
  | "ebook"
  | "vaccination_calendar";
export const ContentPatron = ({
  patron,
  type,
}: {
  patron: PatronVM;
  type: AsidePatronType;
}) => {
  if (!patron) {
    return <></>;
  }

  const { image, substanceImage, substanceLink, link, substanceName, visible } =
    patron;

  if ((!image || !visible) && !substanceImage) {
    return <></>;
  }

  const headings: Record<AsidePatronType, string> = {
    tutorial: "Partner poradnika",
    clinical_case: "Partner przypadku klinicznego",
    article: "Partner artykułu",
    calculator: "Partner kalkulatora",
    ebook: "Partner e-booka",
    vaccination_calendar: "Partner kalendarza szczepień",
  };

  return (
    <div
      className={
        "my-8 flex flex-col items-center justify-center gap-8 text-center"
      }
    >
      {image && visible && (
        <div className={"flex flex-col items-center justify-center"}>
          <div className={`text-foreground mb-3 text-xs font-normal`}>
            {headings[type]}
          </div>
          {link ? (
            <a href={link} target={"_blank"} rel="noreferrer nofollow noopener">
              <PictureUpload
                image={image}
                loaded={true}
                maxHeight={getMaxPatronHeight(image)}
                className={"h-full w-auto"}
              />
            </a>
          ) : (
            <PictureUpload
              image={image as ImageVM}
              loaded={true}
              maxHeight={getMaxPatronHeight(image)}
              className={"h-full w-auto"}
            />
          )}
        </div>
      )}

      {substanceImage && (
        <div className={"flex flex-col items-center justify-center"}>
          <div className={`text-foreground mb-3 text-xs font-normal`}>
            {substanceName
              ? substanceName
              : trans("tutorial.sponsored_substance")}
          </div>
          {substanceLink ? (
            <a
              href={substanceLink}
              target={"_blank"}
              rel="noreferrer nofollow noopener"
            >
              <PictureUpload
                image={substanceImage}
                loaded={true}
                className={"w-auto"}
                maxHeight={getMaxPatronHeight(substanceImage, 1.1)}
              />
            </a>
          ) : (
            <div>
              <PictureUpload
                image={substanceImage}
                loaded={true}
                className={"w-auto"}
                maxHeight={getMaxPatronHeight(substanceImage, 1.1)}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
